"use client"

import Image from "next/image"
import Link from "next/link"
import { Button } from "@/components/ui/button"
import { MessageCircle } from "lucide-react"
import { useContactInfo } from "@/hooks/useContactInfo"

export function HeroSection() {
  const { contactInfo } = useContactInfo()
  return (
    <section
      id="hero"
      className="relative w-full h-[650px] md:h-[750px] lg:h-[850px] overflow-hidden flex items-center justify-center"
    >
      <Image
        src="https://raimerentalsstrg.blob.core.windows.net/commonfile/heroimage.webp"
        alt="Students enjoying a modern shared living space"
        layout="fill"
        objectFit="cover"
        quality={80}
        className="z-0"
      />
      <div className="absolute inset-0 bg-raime-dark-blue bg-opacity-70 flex items-center justify-center text-center p-4 z-10">
        <div className="max-w-4xl space-y-8 text-white px-4">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold leading-tight drop-shadow-lg">
            Tu Hogar Ideal para Estudiantes en España
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl font-light opacity-90">
            Encuentra la habitación perfecta que se adapte a tu estilo de vida y estudios
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link href="/propiedades">
              <Button className="bg-raime-golden-brown hover:bg-raime-golden-brown/90 text-white text-lg px-8 py-7 rounded-full shadow-xl transition-all duration-300 transform hover:scale-105">
                Explora Propiedades
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <Link
        href={`https://wa.me/${contactInfo.displayPhone}?text=Hola, me gustaria obtener informacion`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition-colors z-50"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="h-8 w-8" />
      </Link>
    </section>
  )
}
